import { initialsOf } from '@/hooks/useProfile'

/**
 * A face, or the initials standing in for one.
 *
 * The well is the same shape as a coin well elsewhere in the app, which is the
 * only decoration it gets: a photo that has to fight a border for attention
 * stops reading as a person.
 */
export function Avatar({
  url, name, email, size = 36, className,
}: {
  url?: string | null
  name?: string | null
  email?: string | null
  size?: number
  className?: string
}) {
  return (
    <span
      className={`avatar${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
      aria-hidden="true"
    >
      {url ? (
        <img className="avatar__img" src={url} alt="" width={size} height={size} />
      ) : (
        <span className="avatar__initials">{initialsOf(name, email)}</span>
      )}
    </span>
  )
}
